import DeleteCollection from "./DeleteCollection";

export default DeleteCollection